import FreeSamples from 'components/Content/FreeSamples/FreeSamples';
import { withFreeSamplesProps } from 'viewModel/content/freeSamples/withFreeSamplesProps';

export default withFreeSamplesProps(FreeSamples);
